import React from "react";
import {
  Col,
  Dialog,
  Divider,
  FabButton,
  Flex,
  Gap,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../ppui";
import { TbPencil } from "react-icons/tb";
import {
  CustomTable,
  CustomTableBody,
  CustomTableHeader,
  OrganizationBx,
  OrganizationEmDetails,
  Td,
  Th,
  Tr,
} from "../style";
import usePTaxService from "../statutory/ptax/use-ptax-service";
const StatutoryPtaxStatusDetails = () => {
  const { pTaxInfo } = usePTaxService();
  // Modal
  const [setOpenPtaxModal, setOpenStatutoryPTAXModal] = React.useState(false);

  const handleOpenStatutoryPtaxModal = () => setOpenStatutoryPTAXModal(true);
  const handleCloseStatutoryPtaxModal = () => setOpenStatutoryPTAXModal(false);
  // Modal
  return (
    <>
      <Flex justifyContent="space-between" gap={"10"}>
        <Typography mb={"0"} variant="h5">
          P-Tax Status
        </Typography>

        <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={handleOpenStatutoryPtaxModal}
          variant="filled"
          shape="box"
        />
      </Flex>
      <Gap height={30} />

      <OrganizationEmDetails>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            P-Tax (EC) Code
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            ABF7674J45
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            P-Tax (RC) Code
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            0LLDKRTTG4679
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            State
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Maharashtra
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Financial Year
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            2024
          </Typography>
        </OrganizationBx>
      </OrganizationEmDetails>

      <Divider gap={20} />

      <Typography mb={"0"} variant="h5">
        Professional Tax Slab
      </Typography>

      <Gap height={30} />

      <Row>
        <Col sm={12} md={10}>
          <CustomTable>
            <CustomTableHeader>
              <Tr>
                <Th>
                  <Typography variant="body1" mb={"0"}>
                    MONTHLY GROSS SALARY (₹)
                  </Typography>
                </Th>

                <Th>
                  <Typography variant="body1" mb={"0"}>
                    MONTHLY TAX AMOUNT (₹)
                  </Typography>
                </Th>
              </Tr>
            </CustomTableHeader>

            <CustomTableBody>
              {pTaxInfo?.tax_cal?.map((it) => (
                <Tr key={it?.salary}>
                  <Td>
                    <Typography variant="body1" mb={"0"}>
                      {it?.salary}
                    </Typography>
                  </Td>
                  <Td>
                    <Typography variant="body1" mb={"0"}>
                      {it?.tax_amount}
                    </Typography>
                  </Td>
                </Tr>
              ))}
            </CustomTableBody>
          </CustomTable>
        </Col>
      </Row>

      {/* Statutory-EPF-Modal */}
      <Dialog
        title="P-Tax Status"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={setOpenPtaxModal}
        onClose={handleCloseStatutoryPtaxModal}
        onSubmit={() => alert("Submitted")}
        separator
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              fullWidth
              label="P-TAX(EC) Code"
              placeholder="Type Here..."
              type="text"
              required
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="P-TAX(RC) Code"
              placeholder="Type Here..."
              type="text"
              required
            />
          </Col>

          <Col sm={6}>
            <SelectField
              required
              fullWidth
              label="State"
              options={[
                { id: "option1", name: "West Bengal" },
                {
                  id: "option2",
                  name: "Bihar",
                },
              ]}
              placeholder="Select Here..."
            />
          </Col>

          <Col sm={6}>
            <SelectField
              required
              fullWidth
              label="Financial Years"
              options={[
                { id: "option1", name: "2024" },
                {
                  id: "option2",
                  name: "2025",
                },
              ]}
              placeholder="Select Here..."
            />
          </Col>
        </Row>
      </Dialog>
      {/* Statutory-EPF-Modal */}
    </>
  );
};

export default StatutoryPtaxStatusDetails;
